module.exports = __webpack_public_path__ + "img/W7007-tran.d08d3c82.jpg";